<template>
  <nav class="navbar navbar-inverse pull-left mycol">
    <div class="container-fluid mycontainer-fluid">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle colapsed"
          data-toggle="collapse"
          data-target="#example-navbar-collapse"
          aria-expanded="false"
        >
          <span class="sr-only">Открыть меню</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse" id="example-navbar-collapse">
        <ul
          class="nav navbar-nav"
          v-if="$parent.$parent.currentUser.TYPE_USER === 'declarer'"
        >
          <li
            v-for="(item, index) in mainMenu"
            :key="index"
            :class="item.class"
          >
            <router-link
              :to="{ name: item.route }"
              :class="{ 'router-link-active': isAliasActive(item) }"
              v-html="item.name"
            />
          </li>
          <li>
            <a href="https://spravka.frprf.ru/first-steps" target="_blank">
              Справка
            </a>
          </li>
          <li class="dropdown">
            <a
              href="#"
              class="dropdown-toggle"
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Техподдержка <span class="caret"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu--white">
              <li>
                <router-link :to="{ name: 'Support' }"
                  >Техподдержка</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'Idea' }"
                  >Идея по улучшению кабинета</router-link
                >
              </li>
            </ul>
          </li>
          <li>
            <a href="https://olk.frprf.ru/apps" target="_blank">Иные модули</a>
          </li>
        </ul>
        <ul v-else class="nav navbar-nav">
          <li
            v-for="(item, index) in mainMenu"
            :key="index"
            :class="item.class"
          >
            <router-link
              :to="{
                name: item.route, query: item.query
              }"
              :class="{ 'router-link-active': isAliasActive(item) }"
              v-html="item.name"
            >
            </router-link>
          </li>
          <!--<li v-if="!!getCheckAllExpertiseRoute">
            <router-link :to="{ name: 'ExpertiseAll' }">
              Все экспертизы
            </router-link>
          </li>-->
          <li
            v-if="
              $parent.$parent.currentUser.ACTIVE_ROLE_CODE != 'member_ec' &&
                $parent.$parent.currentUser.ACTIVE_ROLE_CODE != 'member_na' &&
                $parent.$parent.currentUser.ACTIVE_ROLE !== 40
            "
          >
            <a href="https://spravka.frprf.ru/first-steps" target="_blank"
              >Справка
            </a>
          </li>
          <li
            class="dropdown"
            v-if="
              $parent.$parent.currentUser.ACTIVE_ROLE_CODE != 'member_ec' &&
                $parent.$parent.currentUser.ACTIVE_ROLE_CODE != 'member_na' &&
                $parent.$parent.currentUser.ACTIVE_ROLE !== 40
            "
          >
            <a
              href="#"
              class="dropdown-toggle"
              data-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Техподдержка <span class="caret"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu--white">
              <li>
                <router-link :to="{ name: 'Support' }"
                  >Техподдержка</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'Idea' }"
                  >Идея по улучшению кабинета</router-link
                >
              </li>
            </ul>
          </li>
          <li
            v-if="
              $parent.$parent.currentUser.ACTIVE_ROLE_CODE != 'member_na' &&
                $parent.$parent.currentUser.ACTIVE_ROLE !== 40
            "
          >
            <a href="https://olk.frprf.ru/apps" target="_blank">Иные модули </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Products",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["mainMenu", "getCheckAllExpertiseRoute"])
  },
  methods: {
    isAliasActive(item) {
      return (
        Array.isArray(item.routes) && item.routes.includes(this.$route.name)
      );
    }
  }
};
</script>

<style scoped>
.dropdown-menu {
  min-width: 200px;
  background-color: #084872;
}

.dropdown-menu > li > a {
  padding: 8px 20px;
  color: #fff;
  background-color: #084872;
  transition: all 0.3s ease;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: #0a5c94;
  color: #fff;
  text-decoration: none;
}

.dropdown-menu > li > a.router-link-active {
  background-color: #0a5c94;
  color: #fff;
}

.dropdown-toggle .caret {
  margin-left: 5px;
}
</style>
